








import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import FreeInputtableObjectMenu from "./FreeInputtableObjectMenu.vue";

@Component({
  components: {
    FreeInputtableObjectMenu,
  }
})
export default class JoinTextObjectMenu extends Mixins() {
  @Prop()
  source: IFreeInputableWrappedObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get unselectedButtonConfiguration(): { class: string, label: string, description: string } {
    return {
      class: "join-text-object-menu-deselected",
      label: "結合",
      description: "入力方法を結合に切り替えます。",
    };
  }
}
